import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import StickyBody from '../StickyBody/StickyBody';
import CycoPageCoreContent from '../../US/pages/CycoPage/CycoPageCoreContent';
import StickyFooter from '../StickyFooter/StickyFooter';
import Button, { BUTTON_TYPE } from '../Button/Button';
import { FormattedHTMLMessage, FormattedMessage, injectIntl, intlShape } from 'react-intl';
import CancelUrl, { COMPONENT_STYLE } from '../../US/components/CancelUrl/CancelUrl';
import { Form, getFormValues, reduxForm, submit } from 'redux-form';
import { CYCO_FORM_ID } from '../../framework/App/AppConstants';
import { submitCycoApiAction } from './CycoPageActions';
import NotificationBanner, { NOTIFICATION_TYPE } from '../NotificationBanner/NotificationBanner';
import OfferTileGroup from '../OfferTileGroup/OfferTileGroup';
import PopupLink from '../PopupLink/PopupLink';
import _ from 'lodash';
import StickyContainer from '../StickyContainer/StickyContainer';
import { spinnerOpen } from '../../framework/components/FullPageSpinner/FullPageSpinnerActions';
import { trackTransition } from '../../framework/store/FPTI/FPTIActions';
import { scrollToTop } from '../../framework/App/SkeletonPage/SkeletonPageActions';
import { handleSubmitFail } from '../FormElement/FormElementUtils';

const LOCALE_PREFIX = 'components/CycoPageForm/cycoPageForm';

export class CycoPageForm extends Component {
    static propTypes = {
        country: PropTypes.string.isRequired,
        pageName: PropTypes.string.isRequired,
        isCore: PropTypes.bool,
        coreOffer: PropTypes.object,
        isAcq: PropTypes.bool.isRequired,
        isReuse: PropTypes.bool.isRequired,
        acqOrReuse: PropTypes.string.isRequired,
        onClickContinue: PropTypes.func.isRequired,
        mppInstallmentsTermsUrl: PropTypes.string.isRequired,
        serverValidationErrors: PropTypes.object,

        // Comes from injectIntl HOC
        intl: intlShape.isRequired,

        // Provided from decorated reduxForm() component
        handleSubmit: PropTypes.func.isRequired,

        onFormSubmit: PropTypes.func.isRequired,
        formValues: PropTypes.object.isRequired,
        submitFailed: PropTypes.bool.isRequired
    };

    cycoPageContent = (isAcq, acqOrReuse, mppInstallmentsTermsUrl) => {
        const { intl, country, formValues, submitFailed, serverValidationErrors } = this.props;
        const showMustChooseOfferError = (submitFailed || serverValidationErrors) && _.isEmpty(formValues.offer);
        return (
            <React.Fragment>
                <div className="vx_text-3 cycoTitle">
                    <FormattedHTMLMessage id={`${LOCALE_PREFIX}.cyco-page-title-${acqOrReuse}`} />
                </div>
                {isAcq && (
                    <div className="vx_text-3_lighter cycoTitleDesc">
                        <FormattedMessage id={`${LOCALE_PREFIX}.cyco-page-description`} />
                    </div>
                )}
                {showMustChooseOfferError && (
                    <NotificationBanner
                        id="mustChooseOfferError"
                        message={intl.formatMessage({id: `${LOCALE_PREFIX}.cyco-page-must-choose-offer-error`})}
                        type={NOTIFICATION_TYPE.ERROR_FILL}
                        className="validationError"
                    />
                )}
                <div className="cycoOffersContent">
                    <OfferTileGroup localePrefix={LOCALE_PREFIX} />
                    <div className="cycoTerms">
                        {country === 'us' ? <p className="cycoPage-stca cycoPage-stca--ni">
                            {isAcq && (
                                <FormattedHTMLMessage id={`${LOCALE_PREFIX}.cyco-page-terms-and-conditions`}>
                                    {txt => <span>{txt} </span>}
                                </FormattedHTMLMessage>
                            )}
                            <PopupLink className="cycoSeeTermsLink" url={mppInstallmentsTermsUrl}>
                                <FormattedMessage id={`${LOCALE_PREFIX}.cyco-page-see-terms-link`} />
                            </PopupLink>
                        </p> : <p className="cycoPage-stca cycoPage-stca--ni">
                            <FormattedHTMLMessage id={`${LOCALE_PREFIX}.cyco-page-gb-terms-and-conditions`}>
                                {txt => <span>{txt} </span>}
                            </FormattedHTMLMessage>
                        </p>}
                    </div>
                </div>
            </React.Fragment>
        );
    };

    handleSubmit = event => {
        event.preventDefault();
        this.props.onClickContinue(this.props.isCore);
    };

    render() {
        const {pageName, isCore, coreOffer, isAcq, acqOrReuse, mppInstallmentsTermsUrl, handleSubmit, onFormSubmit} = this.props;
        const isCorePostfix = isCore ? '-core' : '';
        return (
            <Form
                id="cyco-form"
                onSubmit={handleSubmit(onFormSubmit)}
            >
                <StickyContainer>
                    <StickyBody>
                        <div className="cyco-offers">
                            {isCore ?
                                (<CycoPageCoreContent coreOffer={coreOffer} />) :
                                this.cycoPageContent(isAcq, acqOrReuse, mppInstallmentsTermsUrl)
                            }
                        </div>
                    </StickyBody>
                    <StickyFooter fixToBottom={false} fadedBackground={true}>
                        <div id="action-buttons" className="vx_btn-group">
                            <Button
                                data-automation-id="continue"
                                className="vx_btn vx_btn-block"
                                btnType={BUTTON_TYPE.SUBMIT}
                            >
                                <FormattedMessage id={`${LOCALE_PREFIX}.cyco-page-continue-btn-${acqOrReuse}${isCorePostfix}`} />
                            </Button>
                            <CancelUrl
                                componentType={COMPONENT_STYLE.LINK_BUTTON}
                                fptiEvent={{
                                    stateName: `pp_credit_${pageName}`,
                                    transitionName: `cancel_pp_credit_${pageName}`
                                }}
                                customCancelLinkMessage={`${LOCALE_PREFIX}.cyco-page-custom-cancel-link`}
                            />
                        </div>
                    </StickyFooter>
                </StickyContainer>
            </Form>
        );
    }
}

export const validate = values => {
    const errors = {};

    if (!values.offer){
        errors.offer = 'Required';
    }

    return errors;
};

export const mapStateToProps = (state, ownProps) => ({
    formValues : getFormValues(CYCO_FORM_ID)(state) || {},
    mppInstallmentsTermsUrl: _.get(state, 'serverData.mppInstallmentsTermsUrl', ''),
    serverValidationErrors: _.get(state, 'cycoPage.cycoValidationErrors'),
    country: _.get(state, 'serverData.country'),
    initialValues: { offer: ownProps.isCore ? _.get(ownProps.coreOffer, 'credit_financing.financing_code') : undefined }
});

export const mapDispatchToProps = dispatch => ({
    onClickContinue() {
        dispatch(submit(CYCO_FORM_ID));
    },
    // handleSubmit will call this function when a form submit is triggered
    // formValues are passed by handleSubmit per api specification
    onFormSubmit(formValues, dispatch, props) {
        const { isReuse, pageName } = props;
        dispatch(spinnerOpen('base.processing'));
        dispatch(submitCycoApiAction(isReuse, formValues));
        dispatch(trackTransition(`pp_credit_${pageName}`, `completeform_pp_credit_${pageName}`));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(
    reduxForm({
        form: CYCO_FORM_ID,
        destroyOnUnmount: false,
        forceUnregisteredOnUnmount: true,
        validate,
        onSubmitFail: handleSubmitFail
    })(CycoPageForm)
));
